import React from 'react';
import Grid from '@mui/material/Grid2';
import Footer from './Footer';

function TermsAndCondition() {
    return(
        <div>
             <Grid item container direction="row" sx={{backgroundColor: '#F8F0F1', paddingTop: '80px', paddingBottom: '80px'}}>
                <Grid item container size={12} sx={{justifyContent: 'center', alignItems: 'center', textAlign: 'center', fontWeight: 'bold', fontSize: '3rem'}}>
                    Terms & Conditions
                </Grid>
                <Grid item container size={12} sx={{justifyContent: 'center', alignItems: 'center', textAlign: 'center'}}>
                    <p>With effect from : 14th Jan 2025 2, 2025</p>
                </Grid>
            </Grid>

            <Grid item container direction="row" className="mt-5">
                <Grid item size={{xs: 12, md: 3}}>
                    <img src='/assets/Vector (1).jpg' className='img-fluid'/>
                </Grid>
                <Grid item size={{xs: 12, md: 6}} sx={{paddingLeft: '15px'}}>
                    <Grid item container direction="column" spacing={2} >
                        <Grid item>
                        Welcome to Yashoda Education & Charitable Trust ("we," "us," "our"). These Terms and Conditions ("Terms") govern your use of our services, website, and any interactions you have with us. By accessing or using our services, you agree to comply with and be bound by these Terms. If you do not agree with these Terms, please do not use our services.
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Acceptance of Terms
                        </Grid>
                        <Grid item>
                        By using our services or accessing our website, you confirm that you have read, understood, and agree to be bound by these Terms and any additional policies or guidelines posted on our website.
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Services Provided
                        </Grid>
                        <Grid item>
                        Yashoda Education & Charitable Trust offers educational and healthcare services aimed at improving the welfare of individuals and communities. Our services may include educational programs, healthcare services, counseling, events, and any other initiatives offered by us from time to time.
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Eligibility
                        </Grid>
                        <Grid item>
                        To use our services, you must be at least 18 years old or the legal age of majority in your jurisdiction. If you are using our services on behalf of an organization, you represent and warrant that you have the authority to bind that organization to these Terms.
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Account Registration
                        </Grid>
                        <Grid item>
                        To access certain features or services, you may be required to create an account with us. When creating an account, you agree to provide accurate and complete information, including your name, email address, phone number, and any other required details.
                        </Grid>
                        <Grid item>
                        You are responsible for maintaining the confidentiality of your account credentials (user ID and password) and for all activities that occur under your account. Notify us immediately if you suspect any unauthorized use of your account.
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Use of Our Services
                        </Grid>
                        <Grid item>
                        You agree to use our services only for lawful purposes and in a way that does not infringe on the rights of others or restrict or inhibit anyone else from using our services. You may not:
                        </Grid>

                      
                        <Grid item>
                            <ul>
                                <li>Use our services for any fraudulent, harmful, or unlawful activities.</li>
                                <li>Attempt to gain unauthorized access to any part of our services or website.</li>
                                <li>Post or transmit any harmful, offensive, or illegal content.</li>
                                <li>Use our website to conduct any activity that violates any applicable law or regulation.</li>                             
                            </ul>
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Payment and Donations
                        </Grid>
                        <Grid item>
                        For certain services, you may be required to make a payment or donation. By making a payment, you agree to provide accurate and valid payment information and authorize us to process such payments.
                        </Grid>
                        <Grid item>
                        We use secure payment methods and third-party processors to handle your payment transactions. By making a donation or payment, you acknowledge that all contributions are final, and refunds will be handled according to our refund policy, if applicable.
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Privacy and Data Protection
                        </Grid>
                        <Grid item>
                        Your use of our services is also governed by our Privacy Policy, which outlines how we collect, use, and protect your personal information. By using our services, you consent to the collection and processing of your data as described in our Privacy Policy.
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Use of Our Services
                        </Grid>

                        <Grid item>
                        You agree to use our services only for lawful purposes and in a way that does not infringe on the rights of others or restrict or inhibit anyone else from using our services. You may not:
                        </Grid>
                        <Grid item>
                            <ul>
                                <li>Use our services for any fraudulent, harmful, or unlawful activities.</li>
                                <li>Attempt to gain unauthorized access to any part of our services or website.</li>
                                <li>Post or transmit any harmful, offensive, or illegal content.</li>
                                <li>Use our website to conduct any activity that violates any applicable law or regulation.</li>
                            </ul>
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Intellectual Property
                        </Grid>
                        <Grid item>
                        All content provided on our website, including text, images, logos, designs, and software, is the property of Yashoda Education & Charitable Trust or its licensors and is protected by copyright, trademark, and other intellectual property laws. You may not use, copy, distribute, or modify any content without prior written permission from us.
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Third-Party Links and Services
                        </Grid>

                        <Grid item>
                        Our website or services may contain links to third-party websites, resources, or services that are not controlled by us. We are not responsible for the content, privacy practices, or availability of these third-party sites. Accessing third-party websites is at your own risk, and we recommend reviewing their terms and privacy policies.
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Disclaimers
                       </Grid>
                       <Grid item>
                       Our services are provided on an "as is" and "as available" basis, without warranties of any kind, either express or implied. We do not guarantee that our services will be error-free, secure, or uninterrupted.
                        </Grid>
                        <Grid item>
                        We disclaim all warranties, including but not limited to, implied warranties of merchantability, fitness for a particular purpose, and non-infringement.
                        </Grid>

                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Limitation of Liability
                        </Grid>
                        <Grid item>
                        To the maximum extent permitted by applicable law, Yashoda Education & Charitable Trust, its affiliates, employees, agents, or contractors will not be liable for any indirect, incidental, special, consequential, or punitive damages arising from or related to your use of our services, even if we have been advised of the possibility of such damages.
                        </Grid>
                        <Grid item>
                        In no event shall our total liability exceed the amount paid by you for the specific service giving rise to the claim.
                       </Grid>
                       <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                       Indemnification
                        </Grid>
                        <Grid item>
                        You agree to indemnify, defend, and hold harmless Yashoda Education & Charitable Trust, its directors, employees, agents, and affiliates from and against any and all claims, losses, damages, liabilities, costs, or expenses (including attorney’s fees) arising out of or in connection with your use of our services, violation of these Terms, or infringement of any third-party rights.          
                      </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Termination
                       </Grid>
                       <Grid item>
                       We reserve the right to suspend or terminate your access to our services at any time, with or without notice, if we believe you have violated these Terms or for any other reason. Upon termination, you must immediately cease all use of our services.
                        </Grid>
                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Governing Law
                        </Grid>
                        <Grid item>
                        These Terms are governed by and construed in accordance with the laws of Banglore, without regard to its conflict of law principles. Any disputes arising from these Terms shall be resolved in the competent courts of Banglore.
                       </Grid>
                       <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                       Changes to Terms
                        </Grid>
                        <Grid item>
                        We reserve the right to update or modify these Terms at any time. We will notify you of any significant changes by posting an updated version of the Terms on our website. Please review these Terms periodically for updates.
                       </Grid>
                       <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                       Severability
                        </Grid>
                        <Grid item>
                        If any provision of these Terms is found to be invalid, illegal, or unenforceable, the remaining provisions will remain in full force and effect.
                       </Grid>
                       <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                       Contact Us
                        </Grid>
                        <Grid item>
                        If you have any questions about these Terms, please contact us at: 9731395555. 9945645985
                        </Grid>

                        <Grid item sx={{fontWeight: 'bold', fontSize: '1.4rem'}}>
                        Yashoda Education & Charitable Trust
                        </Grid>
                        <Grid item>
                        Contact us:  9731395555. 9945645985
                        </Grid>
                        <Grid item>
                        
By accessing or using our services, you acknowledge that you have read, understood, and agreed to these Terms and Conditions.
                       </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Footer/>
        </div>
    );
}

export default TermsAndCondition